import { Helmet } from 'react-helmet';

import ShowroomPage from './pages/showroom.page';
const App: React.FC = () => {
  return (
    <div className={`full-app-container`}>
      <Helmet>
        <title>MG CarStudio</title>
        <meta name="description" content="Meta descripcion del CarStudio MG" />
      </Helmet>
      <ShowroomPage/>
    </div>
  );
};

export default App;
